import BarChartComponent from '@/components/ui/charts/BarChartComponent'
import { useMemo } from 'react'
import { t } from '@lingui/macro'

export type DailyNewPatientsProps = {
  data: Array<{ day: string; newPatientsCount: number }>
  title: string
}

function DailyNewPatientsComponent(props: DailyNewPatientsProps) {
  const { data, title } = props

  const transformedData = useMemo(
    () => [
      {
        label: t`Daily`,
        values: data.map((item) => ({ subLabel: item.day, value: item.newPatientsCount })),
      },
    ],
    [data]
  )

  return <BarChartComponent data={transformedData} title={title} />
}

export default DailyNewPatientsComponent
